import {Pipe, PipeTransform} from '@angular/core';

export type FirstLinePreview = {
    firstLine: string;
    hasMore: boolean;
};

@Pipe({
    name: 'appfirstlinepreview',
    standalone: true,
})
export class FirstLinePreviewPipe implements PipeTransform {
    transform(value: string | null | undefined, maxLength: number): FirstLinePreview {
        const safe = value ?? '';
        const newlineMatch = /\r?\n/.exec(safe);
        const firstLineFull = newlineMatch == null ? safe : safe.slice(0, newlineMatch.index);
        const truncated =
            firstLineFull.length > maxLength ? firstLineFull.slice(0, maxLength) : firstLineFull;
        const hasMore = newlineMatch != null || firstLineFull.length > maxLength;
        return {firstLine: truncated, hasMore};
    }
}
